import type { Component, Style } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import { mapValues } from '../../utils/mapValues'
import { envRefs } from '@wix/thunderbolt-catharsis'

export const viewportSize = createCssCompNode('styleBased', 'viewportSize', {
	getDependencies: (component: Component, refs: FeatureRefs<'styleBased'>) => ({
		compStyles: component.componentType === 'WRichText' ? refs.compStyles(component) : null,
		experiments: envRefs.experiments,
	}),
	toViewItem: (__, { compStyles, experiments }) => {
		if (compStyles?.type !== 'variants') {
			return null
		}

		const shouldFixMinBreakpointTextScale = !!experiments['specs.thunderbolt.customScaleMinBreakpoint']

		const breakpointsMap = mapValues(
			compStyles.css,
			(variants, breakpointId) => breakpointId !== 'default' && Object.values(variants).some(isTextScaled),
		)

		return { ...breakpointsMap, shouldFixMinBreakpointTextScale }
	},
})

const isTextScaled = (style: Style) => {
	const properties = style?.style?.properties
	if (!properties) {
		return false
	}
	return properties.textScale__maxFontSize && properties.textScale__minFontSize
}
